module.exports = __webpack_public_path__ + "img/climate_actions_nature@2x.8a86d11.webp";